module.exports = __webpack_public_path__ + "img/vertical_7_7_8023.6b7d80a0.png";